import * as z from 'zod';
export var createOrUpdateExtraSettingsFormSchema = function () {
    return z.object({
        funnel_id: z.number().min(1),
        responsible_person_id: z.number().min(1),
    });
};
